import { html, LitElement } from 'lit';
import { fileManagerBrowse } from '../modules/FileManagerBrowse.js';
import { icons } from '../utils/SVGIcons.js'
import { live } from 'lit/directives/live.js';

export default class SWLRIFileManagerBrowseFilter extends LitElement {
    static get properties(){
        return {
            _toggledSection:{state:true},
            _currentFilters:{state:true}
        }
    }

    constructor(){
        super();
        this._initFilters()
    }

    createRenderRoot() {
        return this;
    }

    connectedCallback(){
        super.connectedCallback();
        window.addEventListener('swlri-file-manager-browse-toggle-filter-panel', this._toggleFilterPanel.bind(this))
    }

    _toggleFilterPanel(e){
        let open = e.detail;
        if(open){
            this.classList.add('swlri-file-manager-browse-panel-filter-open');
        } else this.classList.remove('swlri-file-manager-browse-panel-filter-open')
    }

    _notifyClosePanel(){
        fileManagerBrowse.filterPanelOpened = false;
    }

    _initFilters(){
        this._toggledSection = fileManagerBrowse.fieldConfiguration.reduce((acc,f)=>{
            acc[f.reference] = false;
            return acc;
        },{})
        this._currentFilters = fileManagerBrowse.fieldConfiguration.reduce((acc,f)=>{
            acc[f.reference] = null;
            return acc;
        },{})

        this._filterFileList();
    }

    _getSectionIcon(ref){
        if(this._toggledSection[ref]) return icons.chevDown;
        else return icons.chevRight;
    }

    _toggleSection(e){
        let ref = e.currentTarget?.getAttribute("toggle-for");
        if(ref){
            this._toggledSection[ref] = !this._toggledSection[ref];
        }

        this._toggledSection = {...this._toggledSection}
    }


    _getField(reference){
        let field = fileManagerBrowse.fieldConfiguration.filter((f)=>{
            return f.reference == reference;
        })
        if(field.length == 1) return field[0];
        else return null;
    }

    _filterFileList(){
        // parse filter
        let filters = this._getFilters();
        fileManagerBrowse.fileFilters = filters;

    }

    _getFilters(){
        return Object.keys(this._currentFilters).reduce((acc, curr)=>{
            if(this._currentFilters[curr]){
                if(this._currentFilters[curr] instanceof Set){
                    let setArray = this._currentFilters[curr].keys().toArray();
                    if(setArray.length){
                        acc[curr] = setArray;
                    }
                } else if(typeof this._currentFilters[curr] == 'string'){
                    acc[curr] = this._currentFilters[curr];
                }
            }
            return acc;
        }, {})
    }

    _updateFilter(e){
        let ref = e.currentTarget?.getAttribute("filter");
        if(ref){
            let field = this._getField(ref);
            if(field.input_type == 'dropdown' || field.input_type == 'multiselect'){
                let addFilter = e.currentTarget.checked;
                let filterVal = e.currentTarget?.getAttribute('filter-val');
                if(filterVal){
                    let currentFilter = this._currentFilters[ref];
                    if(!currentFilter) this._currentFilters[ref] = new Set();
                    if(addFilter){
                        this._currentFilters[ref].add(+filterVal)
                    } else this._currentFilters[ref].delete(+filterVal)
                    this._filterFileList();
                }
            } else if(field.input_type == 'text' || field.input_type == 'hidden' || field.input_type == 'textarea' || field.input_type == 'datetime'){
                let addFilter = e.currentTarget?.value ?? '';
                this._currentFilters[ref] = addFilter
            }
        }
    }

    _setSearchInputFromSelection(e){
        e.preventDefault()
        e.stopPropagation()
        let ref = e.currentTarget?.getAttribute('for-field');
        let filterVal = e.currentTarget?.getAttribute('filter-val');
        if(ref) {
            let input = this.querySelector('input[filter="'+ref+'"]')
            if(input){
                input.value = filterVal ?? '';
                this._currentFilters[ref] = filterVal ?? '';
                this._filterFileList();
            }
        }
    }

    _getValuesToDisplay(field){
        if(field.input_type == 'text' || field.input_type == 'hidden' || field.input_type == 'textarea'){
            return html`
                ${field.pre_select.map((m)=>{
                    return html`<div class='swlri-file-manager-browse-pre-search' @click=${this._setSearchInputFromSelection} for-field=${field.reference} filter-val=${m.tp}>
                        <span class='swlri-file-manager-browse-pre-search-label'>${m.label}</span>
                        <span class='swlri-file-manager-browse-pre-search-count'>${m.c}</span>
                    </div>`
                })}
                <div class='swlri-file-manager-browse-text-filter'>
                    <input .value="${live(this._currentFilters[field.reference])}" @change=${this._updateFilter} filter=${field.reference} class='swlri-file-manager-browse-text-filter-input' type='text'/><span @click=${this._filterFileList} class='swlri-file-manager-browse-text-filter-icon'>${icons.searchIcon}</span>
                </div>
                `
        } else if (field.input_type == 'dropdown' || field.input_type == 'multiselect'){
            return html`${field.tag_values.map((t)=>{
                return html`
                <div class='swlri-file-manager-browse-checkbox-filter'>
                    <input .checked="${live(this._currentFilters[field.reference] instanceof Set && this._currentFilters[field.reference].has(t.id))}" filter='${field.reference}' @change=${this._updateFilter} filter-val=${t.id} type='checkbox' class='swlri-file-manager-browse-text-filter-checkbox'/><label>${t.value}</label>
                </div>
                `
            })}`
        } else if(field.input_type == 'datetime'){
            return html`
                <div class='swlri-file-manager-browse-text-filter'>
                    <input .value="${live(this._currentFilters[field.reference])}" type="hidden" class='swlri-file-manager-browse-text-filter-input' filter=${field.reference} @change=${this._updateFilter}/>
                    <input .value="${live(this._currentFilters[field.reference])}" for-filter=${field.reference} class='swlri-file-manager-browse-text-filter-input swlri-file-manager-browse-datepicker' type='text'/><span @click=${this._filterFileList} class='swlri-file-manager-browse-text-filter-icon'>${icons.searchIcon}</span>
                </div>
            `
        }
        else return html``;
    }

    updated(){
        // attach calendar to datetime inputs
        if(jQuery(this).find('.swlri-file-manager-browse-datepicker').length > 0 && jQuery(this).find('.swlri-file-manager-browse-datepicker.dp-initialized').length == 0){
            jQuery(this).find('.swlri-file-manager-browse-datepicker').datepicker({
                onClose: (date,element)=>{
                    // validate date
                    let strjs = "";
                    try{
                        let datejs = jQuery.datepicker.parseDate('dd M yy', date)
                        if( datejs instanceof Date){
                            strjs = datejs.getFullYear()+"-"+(datejs.getMonth()+1 < 10 ? "0" + datejs.getMonth()+1 : datejs.getMonth()+1)+"-"+(datejs.getDate() < 10 ? "0"+datejs.getDate() : datejs.getDate())
                        }
                    } catch(e){
                        strjs = '';
                        element.input[0].value = '';
                    }
                    let attrLinked = element.input[0].getAttribute('for-filter');
                    let linkedElement = element.input[0].parentElement.querySelector("[filter='"+attrLinked+"']");
                    if(linkedElement) linkedElement.value = strjs;
                    linkedElement.dispatchEvent(new Event('change'))
                },
                dateFormat: 'dd M yy'

            }
            ).addClass('dp-initialized');
        }
    }

    _validateDate(e){
        let date = e.currentTarget.value ?? '';
        if(date){
            try {
                jQuery.datepicker.parseDate('dd M yy', date);
            } catch(e){

            }
        }
    }

    _resetFilters(e){
        this._currentFilters = fileManagerBrowse.fieldConfiguration.reduce((acc,f)=>{
            acc[f.reference] = null;
            return acc;
        },{})
        this._filterFileList();
    }

    render(){
        return html`<div class="swlri-file-manager-browse-filter-container">
            <div class="swlri-file-manager-browse-filter-header">
                <h5 class='swlri-file-manager-browse-filter-header-title'>Filters <span class='swlri-file-manager-browse-filter-arrow chev-left' @click=${this._notifyClosePanel}>${icons.chevLeft}</span></h5>
                <h5 class="swlri-file-manager-browse-filter-header-clear" @click=${this._resetFilters}>Clear</h5>
            </div>
            ${fileManagerBrowse.fieldConfiguration.map((f)=>{
                return html`
                    <div class="swlri-file-manager-browse-filter-section">
                        <div class="swlri-file-manager-browse-filter-title">
                            <span class='swlri-file-manager-browse-filter-arrow${this._toggledSection[f.reference] ? ' chev-down':' chev-right'}' toggle-for="${f.reference}" @click=${this._toggleSection}>${this._getSectionIcon(f.reference)}</span>
                            <span>${f.label}</span>
                        </div>
                        <div class="swlri-file-manager-browse-filter-values ${this._toggledSection[f.reference] ? 'swlri-file-manager-browse-filter-expanded' : ''}">
                            ${this._getValuesToDisplay(f)}
                        </div>
                    </div>`;
            })}
        </div>`;
    }
}